<p-breadcrumb [model]="items" [home]="home">
  <ng-template #item let-item>
    <a class="item p-breadcrumb-item-link"
      [ngClass]="{'value': !!item.value, 'selected': item.label === selectedLabel }"
      (click)="onItemClick(item.label)">
      <div [class]="item.icon" class="hidden-xxs"></div>
      @if (!item.value) {
        <div class="label hidden-xs">{{ ("reservations." + item.label) | translate }}</div>
      }
      @if (item.value) {
        <div>{{ item.value | stringFormat: { format: item.format } }}</div>
      }
    </a>
  </ng-template>
</p-breadcrumb>
